import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { get } from 'lodash';

import {
  default as AssignmentDialog,
  AssignmentDialogModes
} from 'pages/Teachers/shared/AssignmentDialog';
import { useDialog } from 'utils/hooks';
import { parseParams } from 'utils/urls';

import AssignmentDialogContext from 'components/AssignmentDialogContext';

const AssignmentCreateDialogContext = React.createContext({
  defaultMode: AssignmentDialogModes.CREATE,
  isAssignmentCreateDialogOpened: false,
  setIsAssignmentCreateDialogOpened: () => {}
});

export const AssignmentCreateDialogContextProvider = ({ children }) => {
  const { openDialog, closeDialog, isOpened } = useDialog();

  const history = useHistory();

  const searchParams = parseParams(history.location.search);
  const bulkUploadId = get(searchParams, 'bulkUploadId');

  const [selectedAssignment, setSelectedAssignment] = useState(null);
  const [assignmentTemplateId, setAssignmentTemplateId] = useState(null);
  const [isAcceleratedCurriculum, setIsAcceleratedCurriculum] = useState(null);
  const [assignmentCreateDialogMode, setAssignmentCreateDialogMode] = useState(
    AssignmentDialogModes.CREATE
  );
  const [isMathAssignment, setIsMathAssignment] = useState(false);

  const { isAssignmentDialogOpened, setIsAssignmentDialogOpened } = useContext(
    AssignmentDialogContext
  );

  useEffect(() => {
    if (isAssignmentDialogOpened && isOpened) {
      setIsAssignmentDialogOpened(false);
    }
  }, [isOpened, isAssignmentDialogOpened, setIsAssignmentDialogOpened]);

  const open = ({
    mode = AssignmentDialogModes.CREATE,
    selectedAssignment = null,
    assignmentTemplateId = null,
    isAcceleratedCurriculum = null,
    isMathAssignment = false
  }) => {
    setAssignmentCreateDialogMode(mode);
    setSelectedAssignment(selectedAssignment);
    setAssignmentTemplateId(assignmentTemplateId);
    setIsAcceleratedCurriculum(isAcceleratedCurriculum);
    setIsMathAssignment(isMathAssignment);

    openDialog();
  };

  const close = () => {
    setSelectedAssignment(null);
    setAssignmentTemplateId(null);
    closeDialog();
  };

  return (
    <AssignmentCreateDialogContext.Provider
      value={{
        open,
        isOpened,
        closeDialog
      }}
    >
      {children}

      {isOpened && (
        <AssignmentDialog
          defaultMode={assignmentCreateDialogMode}
          isMathAssignment={isMathAssignment}
          assignmentTemplateId={assignmentTemplateId}
          isAcceleratedCurriculum={isAcceleratedCurriculum}
          defaultTrackerId={get(selectedAssignment, 'tracker_id')}
          bulkUploadId={bulkUploadId}
          onClose={close}
        />
      )}
    </AssignmentCreateDialogContext.Provider>
  );
};

export default AssignmentCreateDialogContext;
